import { render, staticRenderFns } from "./ViewVehicleNotes.vue?vue&type=template&id=3ebd2322&scoped=true"
import script from "./ViewVehicleNotes.vue?vue&type=script&lang=js"
export * from "./ViewVehicleNotes.vue?vue&type=script&lang=js"
import style0 from "./ViewVehicleNotes.vue?vue&type=style&index=0&id=3ebd2322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebd2322",
  null
  
)

export default component.exports